if (!customElements.get('swatch-groups')) {
  class SwatchGroups extends HTMLElement {
    selectors = {
      trigger: '[data-group]',
      swatches: '[swatch-group="option-selector"]',
      wrapper: '[data-selectors-wrapper]',
      swatchWrapper: '[data-swatches-container]'
    }

    helpers = {
      active: 'is-active',
      hidden: 'hidden'
    }

    constructor() {
      super();
    }
    
    connectedCallback() {
      this.elements = {
        triggers: [...this.querySelectorAll(this.selectors.trigger)],
        wrapper: this.closest(this.selectors.wrapper),
      };
      this.elements.swatches = [...this.elements.wrapper.querySelectorAll(this.selectors.swatches)];
      this.elements.swatchWrapper = this.elements.wrapper.querySelector(this.selectors.swatchWrapper);
      this.data = JSON.parse(this.querySelector('script').textContent);
      
      if (
        !this.elements.triggers?.length 
        || !this.elements.swatches?.length 
        || !this.data 
      ) {
        return console.error('missing elements in swatchGroup')
      };

      this.selectedGroup = this.elements.triggers.find(trigger => trigger.classList?.contains(this.helpers.active))?.getAttribute('data-group');

      this.elements.triggers.forEach(trigger => {
        trigger.addEventListener('click', this.handleTriggerClick.bind(this))
      })

      this.filterSwatches();
    }

    /**
     * Handle trigger click.
     * @param {Event} e 
     * @returns {Void}
     */
    handleTriggerClick(e) {
      e.preventDefault();

      if (e.target.classList.contains(this.helpers.active)) {
        return;
      }

      this.elements.triggers.forEach(trigger => {
        if (trigger == e.target) {
          e.target.classList.add(this.helpers.active)

          return;
        }

        trigger.classList.remove(this.helpers.active)
      })

      this.selectedGroup = e.target.getAttribute('data-group');

      this.filterSwatches();
    }

    /**
     * Filter swatches.
     */
    filterSwatches() {
      const selectedGroupOptions = this.data.groups[this.selectedGroup];

      const filteredSwatches = this.elements.swatches.filter(swatch => {
        const handle = swatch.getAttribute('data-value-handle')

        return selectedGroupOptions.find(option => option == handle);
      })

      // Toggle individual swatches visibility.
      this.elements.swatches.forEach(swatch => {
        swatch.closest('[data-swatches-button]').classList.toggle(
          this.helpers.hidden, 
          !filteredSwatches.find(
            fswatch => swatch.getAttribute('data-value-handle') == fswatch.getAttribute('data-value-handle')
          )
        )
      })
      
      // Select first visible swatch from list.
      const swatchToSelect =  filteredSwatches.find(swatch => !swatch.parentElement.classList.contains('unavailable') && !swatch.parentElement.classList.contains('sold-out'))
      
      swatchToSelect 
      ? swatchToSelect.click()
      : filteredSwatches[0].click();

      this.elements.swatchWrapper?.classList.toggle(
        this.helpers.hidden, 
        filteredSwatches.length == 1
      )
    }
  }
  customElements.define('swatch-groups', SwatchGroups);
}